// external libs
import { Box } from '@material-ui/core'

// components
import ButtonSubmittedWithdraw from '../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'
import RevertProjectStatus from '../revertProjectStatus/RevertProjectStatus'

// hooks & stores
import useAppFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useCheckPermission from '../../../../utilities/checkPermission'

// constants
import submittedStatus from '../../../../constants/submittedStatus'

// types
import type { GetProjectResultType as Project } from '../../../../services/web/types/responseWebServiceTypes'
import type { FolderType } from '../../../../stores/appFolderAndTab/appFolderAndTabStore'

export interface ProjectHeaderActionsProps {
    project: Project
}

const ProjectHeaderActions = (props: ProjectHeaderActionsProps) => {
    const { project } = props

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const checkPermission = useCheckPermission()

    const isUserAdmin = checkPermission.isUserAdmin()

    const currentProjectSubmittedStatusId = project.submittedStatusInfo?.value
    const isProjectCompleted = currentProjectSubmittedStatusId === submittedStatus.complete

    const latestFolder: FolderType = appFolderAndTabStore.folderList[0]
    const currentFolder: FolderType = appFolderAndTabStore.folderSelected
    const isLatestFolder = latestFolder?.submittedID === currentFolder?.submittedID

    const canRevertProjectStatus = isUserAdmin && !isProjectCompleted && isLatestFolder

    return (
        <Box display="flex" justifyContent="flex-end" width="100%" style={{ gap: 16 }}>
            <ButtonSubmittedWithdraw />

            {canRevertProjectStatus ? <RevertProjectStatus project={project} /> : null}
        </Box>
    )
}

export default ProjectHeaderActions
